<template>
  <form-section :title="title">
    <template slot="controls">
      <content-actions
        v-model="value"
        :channel="$route.query.channel"
        import-enabled
        export-enabled
        :import-export-inactive="
          !$can('updateProjectItem') && model.onsite_type === onsiteTypes.INLINE
        "
        apply-template-enabled
        copy-enabled
        :is-content-empty="disabled"
        :model="model"
      />
      <slot name="selected-template-info"></slot>
    </template>
    <el-row>
      <el-col :md="24" :lg="10" :xl="8">
        <form-item
          prop="onsite_type"
          :label="$t('CampaignForm_Onsite_Field_Type')"
        >
          <enum-select
            v-model="messageModel.onsite_type"
            :options="onsiteAvailableTypes"
            :number="true"
            data-qa="onsite-type-dropdown"
          />
        </form-item>
        <template v-if="messageModel.onsite_type === onsiteTypes.ALERT">
          <form-item
            prop="push_title"
            :label="$t('CampaignForm_Onsite_Field_Title')"
          >
            <snippet-input
              v-model="messageModel.push_title"
              data-qa="onsite-alert-title-input"
            />
          </form-item>
          <form-item
            class="editor"
            prop="push_text"
            :label="$t('CampaignForm_Onsite_Field_Text')"
          >
            <snippet-input
              type="textarea"
              v-model="messageModel.push_text"
              data-qa="onsite-alert-message-input"
            />
          </form-item>
          <form-item
            prop="action"
            :label="$t('CampaignForm_Onsite_Field_DefaultAction')"
          >
            <enum-select
              :options="actions"
              v-model="actionModel"
              data-qa="onsite-alert-default-action-dropdown"
            />
          </form-item>
          <!-- Actions -->
          <form-item
            v-if="messageModel.push_action.action === 'url'"
            prop="url"
            :label="$t('CampaignForm_Onsite_Field_Url')"
          >
            <el-input
              v-model="messageModel.push_action.url"
              data-qa="onsite-alert-url-input"
            />
          </form-item>
          <form-item
            v-if="messageModel.push_action.action === 'deeplink'"
            prop="deeplink"
            :label="$t('CampaignForm_Onsite_Field_Deeplink')"
          >
            <el-input
              v-model="messageModel.push_action.deeplink"
              data-qa="onsite-alert-deeplink-input"
            />
          </form-item>
          <form-item
            v-if="messageModel.push_action.action === 'javascript'"
            prop="javascript"
            :label="$t('CampaignForm_Onsite_Field_Javascript')"
          >
            <el-input
              type="textarea"
              v-model="messageModel.push_action.javascript"
              data-qa="onsite-alert-javascript-input"
            />
          </form-item>
          <!-- ----- -->
          <form-item
            prop="push_icon"
            :label="$t('CampaignForm_Onsite_Field_Icon')"
          >
            <campaign-image-upload
              class="upload"
              :file.sync="messageModel.push_icon"
              :value="messageModel.push_icon"
              :message-type="channelTypes.onsite"
              upload-type="alert"
              size="small"
            />
          </form-item>
        </template>
        <el-tabs
          v-if="messageModel.onsite_type === onsiteTypes.POPUP"
          v-model="tab"
          class="tabs"
          :stretch="true"
        >
          <el-tab-pane
            name="content"
            :label="$t('CampaignForm_Onsite_Tab_Content')"
          >
            <form-item :label="$t('CampaignForm_Onsite_Field_Form')">
              <el-select
                v-model="messageModel.onsite.popup.email_checkbox"
                data-qa="onsite-popup-form-dropdown"
              >
                <el-option
                  :value="0"
                  :label="$t('CampaignForm_Onsite_EmailSubmit_None')"
                  data-qa="onsite-form-none-option"
                />
                <el-option
                  :value="1"
                  :label="$t('CampaignForm_Onsite_EmailSubmit_Email')"
                  data-qa="onsite-form-email-option"
                />
              </el-select>
            </form-item>
            <form-item
              v-if="messageModel.onsite.popup.email_checkbox"
              :label="$t('CampaignForm_Onsite_Field_MarketingOptIn')"
            >
              <el-select
                v-model="messageModel.onsite.popup.email_subscription"
                data-qa="onsite-popup-marketing-dropdown"
              >
                <el-option
                  :value="1"
                  :label="$t('CampaignForm_Onsite_MarketingOptIn_Yes')"
                  data-qa="onsite-marketing-yes-option"
                />
                <el-option
                  :value="0"
                  :label="$t('CampaignForm_Onsite_MarketingOptIn_No')"
                  data-qa="onsite-marketing-no-option"
                />
              </el-select>
            </form-item>
            <form-item
              v-if="messageModel.onsite.popup.email_checkbox"
              :label="$t('CampaignForm_Onsite_Field_OnSubmit')"
            >
              <el-select
                v-model="messageModel.onsite.popup.email_submit.action"
                data-qa="onsite-popup-on-submit-dropdown"
              >
                <el-option
                  value="dismiss"
                  :label="$t('CampaignForm_Onsite_OnSubmit_Dismiss')"
                  data-qa="onsite-submit-dismiss-option"
                />
                <el-option
                  value="standard"
                  :label="$t('CampaignForm_Onsite_OnSubmit_Standard')"
                  data-qa="onsite-submit-standard-option"
                />
                <el-option
                  value="javascript"
                  :label="$t('CampaignForm_Onsite_OnSubmit_Javascript')"
                  data-qa="onsite-submit-javascript-option"
                />
              </el-select>
            </form-item>
            <form-item
              v-if="
                messageModel.onsite.popup.email_checkbox &&
                  messageModel.onsite.popup.email_submit.action === 'javascript'
              "
              :label="$t('CampaignForm_Onsite_Field_Javascript')"
            >
              <el-input
                type="textarea"
                v-model="messageModel.onsite.popup.email_submit.javascript"
                data-qa="onsite-submit-javascript-input"
              />
            </form-item>
            <form-item :label="$t('CampaignForm_Onsite_Field_Buttons')">
              <el-select
                :value="enabledButtons"
                @change="setValue"
                data-qa="onsite-popup-buttons-dropdown"
              >
                <el-option
                  :value="0"
                  :label="$t('CampaignForm_Onsite_Buttons_None')"
                  data-qa="onsite-buttons-none-option"
                />
                <el-option
                  :value="1"
                  :label="$t('CampaignForm_Onsite_Buttons_1')"
                  data-qa="onsite-buttons-one-option"
                />
                <el-option
                  :value="2"
                  :label="$t('CampaignForm_Onsite_Buttons_2')"
                  data-qa="onsite-buttons-two-option"
                />
              </el-select>
            </form-item>
            <!-- Image -->
            <form-section class="checkbox m-top-20">
              <form-item prop="image_checkbox">
                <checkbox
                  label="image_checkbox"
                  :title="$t('CampaignForm_Onsite_Field_Image')"
                  v-model="messageModel.onsite.popup.image_checkbox"
                  data-qa="onsite-image-checkbox"
                />
              </form-item>
              <template v-if="messageModel.onsite.popup.image_checkbox">
                <form-item>
                  <enum-select
                    class="select"
                    :options="imageOptions"
                    v-model="messageModel.onsite.popup.image_type"
                    data-qa="onsite-image-dropdown"
                  />
                </form-item>
                <template
                  v-if="
                    ['upload', 'url'].includes(
                      messageModel.onsite.popup.image_type
                    )
                  "
                >
                  <el-row>
                    <el-col :span="17">
                      <form-item
                        prop="image"
                        v-if="messageModel.onsite.popup.image_type === 'upload'"
                        :label="$t('CampaignForm_Onsite_Field_UploadImage')"
                      >
                        <campaign-image-upload
                          class="upload"
                          :file.sync="messageModel.onsite.popup.image"
                          :value="messageModel.onsite.popup.image"
                          :message-type="channelTypes.onsite"
                          :show-url="false"
                          upload-type="popup"
                          size="small"
                        />
                      </form-item>
                      <form-item
                        v-else
                        prop="image_url"
                        :label="$t('CampaignForm_Onsite_Field_ImageUrl')"
                      >
                        <el-input
                          v-model="messageModel.onsite.popup.image_url"
                          data-qa="onsite-popup-image-url-input"
                        />
                      </form-item>
                    </el-col>
                    <el-col :span="7">
                      <form-item
                        prop="image_height"
                        :label="$t('CampaignForm_Onsite_Field_Height')"
                      >
                        <el-input
                          :placeholder="
                            $t('CampaignForm_Onsite_Field_Height_Placeholder')
                          "
                          v-model="messageModel.onsite.popup.image_height"
                          data-qa="onsite-popup-image-height-input"
                        />
                      </form-item>
                    </el-col>
                  </el-row>
                  <form-item
                    prop="image_link"
                    :label="$t('CampaignForm_Onsite_Field_LinkUrl')"
                  >
                    <el-input
                      v-model="messageModel.onsite.popup.image_link"
                      data-qa="onsite-popup-image-link-input"
                    />
                  </form-item>
                </template>
              </template>
            </form-section>
            <!-- Title -->
            <form-section class="checkbox redactor">
              <form-item prop="title_checkbox">
                <checkbox
                  label="title_checkbox"
                  :title="$t('CampaignForm_Onsite_Field_PopupTitle')"
                  v-model="messageModel.onsite.popup.title_checkbox"
                  data-qa="onsite-title-checkbox"
                />
              </form-item>
              <form-item
                key="title"
                prop="title"
                class="redactor"
                v-if="messageModel.onsite.popup.title_checkbox"
              >
                <redactor
                  v-model="messageModel.onsite.popup.title"
                  :plugins="['source', 'personalization']"
                  :key="titleKey"
                  :custom-config="{
                    tabKey: false,
                    enterKey: false,
                    maxHeight: 50
                  }"
                  data-qa="onsite-title-input"
                />
              </form-item>
            </form-section>

            <!-- Text -->
            <form-section class="checkbox redactor">
              <form-item prop="text_checkbox">
                <checkbox
                  label="text_checkbox"
                  :title="$t('CampaignForm_Onsite_Field_PopupText')"
                  v-model="messageModel.onsite.popup.text_checkbox"
                  data-qa="onsite-text-checkbox"
                />
              </form-item>
              <form-item
                key="text"
                prop="text"
                class="redactor"
                v-if="messageModel.onsite.popup.text_checkbox"
              >
                <redactor
                  v-model="messageModel.onsite.popup.main_text"
                  :key="textKey"
                  :buttons="['ol', 'ul']"
                  :plugins="[
                    'source',
                    'alignment',
                    'fontcolor',
                    'personalization'
                  ]"
                  :custom-config="{
                    minHeight: 55,
                    maxHeight: 200,
                    allowedTags: ['span', 'br', 'div'],
                    removeEmpty: ['span', 'p'],
                    linebreaks: true
                  }"
                  data-qa="onsite-text-input"
                />
              </form-item>
            </form-section>
            <!-- Button 1 --->
            <on-site-button-form
              v-if="enabledButtons"
              v-model="messageModel.onsite.popup.button0"
              button="1"
            />
            <!-- Button 2 --->
            <on-site-button-form
              v-if="enabledButtons > 1"
              v-model="messageModel.onsite.popup.button1"
              button="2"
            />
            <!-- Inline Preference -->
            <form-section class="creative checkbox">
              <inline-preference
                :key="inlinePreferenceKey"
                v-if="value.onsite_type === onsiteTypes.POPUP"
                v-model="messageModel.onsite.popup.inline_preference"
                on-site-terms
              />
            </form-section>
            <!-- Footer -->
            <form-section class="checkbox">
              <form-item prop="footer_checkbox">
                <checkbox
                  label="footer_checkbox"
                  :title="$t('CampaignForm_Onsite_Field_Footer')"
                  v-model="messageModel.onsite.popup.footer_checkbox"
                />
              </form-item>
              <form-item
                prop="text"
                v-if="messageModel.onsite.popup.footer_checkbox"
              >
                <redactor
                  v-model="messageModel.onsite.popup.footer"
                  :key="footerKey"
                  :buttons="['ol', 'ul']"
                  :plugins="[
                    'source',
                    'alignment',
                    'fontcolor',
                    'personalization'
                  ]"
                  :custom-config="{
                    minHeight: 55,
                    maxHeight: 200,
                    allowedTags: ['span', 'br', 'div'],
                    removeEmpty: ['span', 'p'],
                    linebreaks: true
                  }"
                />
              </form-item>
            </form-section>
          </el-tab-pane>
          <el-tab-pane
            name="styles"
            :label="$t('CampaignForm_Onsite_Tab_Styles')"
            class="styles"
          >
            <el-row class="styles-section">
              <el-col :span="12">
                <form-item :label="$t('CampaignForm_Onsite_Field_Width')">
                  <el-input-number
                    class="input-number"
                    v-model="messageModel.onsite.popup.message_size.width"
                    controls-position="right"
                    :min="0"
                  />
                </form-item>
                <form-item :label="$t('CampaignForm_Onsite_Field_Opacity')">
                  <el-input-number
                    class="input-number"
                    v-model="messageModel.onsite.popup.style.opacity_backdrop"
                    controls-position="right"
                    :min="0"
                  />
                </form-item>
                <form-item :label="$t('CampaignForm_Onsite_Field_Opacity')">
                  <el-input-number
                    class="input-number"
                    v-model="messageModel.onsite.popup.style.opacity_background"
                    controls-position="right"
                    :min="0"
                  />
                </form-item>
              </el-col>
              <el-col :span="12">
                <form-item :label="$t('CampaignForm_Onsite_Field_Vscroll')">
                  <enum-select
                    class="select"
                    :options="scrollOptions"
                    v-model="messageModel.onsite.popup.message_size.scroll"
                  />
                </form-item>

                <color-picker-field
                  v-model="messageModel.onsite.popup.style.color_backdrop"
                  :label-text="$t('CampaignForm_Onsite_Field_Backdrop')"
                />
                <color-picker-field
                  v-model="messageModel.onsite.popup.style.color_background"
                  :label-text="$t('CampaignForm_Onsite_Field_Background')"
                />
              </el-col>
            </el-row>
            <el-row class="styles-section">
              <el-col :span="12">
                <color-picker-field
                  v-model="messageModel.onsite.popup.style.color_title"
                  :label-text="$t('CampaignForm_Onsite_Field_TitleColor')"
                />

                <color-picker-field
                  v-if="enabledButtons"
                  v-model="
                    messageModel.onsite.popup.style.color_button_0_background
                  "
                  :label-text="
                    $t('CampaignForm_Onsite_Field_ButtonColor', { btn: '1' })
                  "
                />
                <color-picker-field
                  v-if="enabledButtons > 1"
                  v-model="
                    messageModel.onsite.popup.style.color_button_1_background
                  "
                  :label-text="
                    $t('CampaignForm_Onsite_Field_ButtonColor', { btn: '2' })
                  "
                />
              </el-col>
              <el-col :span="12" class="p-right-15">
                <color-picker-field
                  v-model="messageModel.onsite.popup.style.color_text"
                  :label-text="$t('CampaignForm_Onsite_Field_TextColor')"
                />
                <color-picker-field
                  v-if="enabledButtons"
                  v-model="messageModel.onsite.popup.style.color_button_0_text"
                  :label-text="$t('CampaignForm_Onsite_Field_Label')"
                />
                <color-picker-field
                  v-if="enabledButtons > 1"
                  v-model="messageModel.onsite.popup.style.color_button_1_text"
                  :label-text="$t('CampaignForm_Onsite_Field_Label')"
                />
              </el-col>
            </el-row>
            <el-row
              class="styles-section"
              v-if="messageModel.onsite.popup.inline_preference.enabled"
            >
              <el-col :span="12">
                <color-picker-field
                  v-model="
                    messageModel.onsite.popup.style.color_inline_checkbox
                  "
                  :label-text="$t('CampaignForm_InApp_Field_Inline_Checkbox')"
                />
                <color-picker-field
                  v-model="
                    messageModel.onsite.popup.style
                      .color_inline_button_background
                  "
                  :label-text="$t('CampaignForm_InApp_Field_Inline_Button')"
                />
                <color-picker-field
                  v-model="
                    messageModel.onsite.popup.style.color_inline_button_border
                  "
                  :label-text="
                    $t('CampaignForm_InApp_Field_Inline_Button_Border')
                  "
                />
              </el-col>
              <el-col :span="12">
                <color-picker-field
                  v-model="messageModel.onsite.popup.style.color_inline_text"
                  :label-text="$t('CampaignForm_InApp_Field_Inline_Text')"
                />
                <color-picker-field
                  v-model="
                    messageModel.onsite.popup.style.color_inline_button_text
                  "
                  :label-text="
                    $t('CampaignForm_InApp_Field_Inline_Button_Text')
                  "
                />
              </el-col>
            </el-row>
            <el-row
              class="styles-section"
              v-if="messageModel.onsite.popup.footer_checkbox"
            >
              <el-col :span="12">
                <color-picker-field
                  v-model="messageModel.onsite.popup.style.color_footer"
                  :label-text="$t('CampaignForm_Onsite_Field_FooterColor')"
                />
              </el-col>
              <el-col :span="12">
                <color-picker-field
                  v-model="
                    messageModel.onsite.popup.style.color_footer_separator
                  "
                  :label-text="$t('CampaignForm_Onsite_Field_Separator')"
                />
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
        <div
          v-if="
            messageModel.onsite.native &&
              messageModel.onsite_type === onsiteTypes.INLINE
          "
        >
          <native-inline-form :message="messageModel.onsite" />
        </div>
      </el-col>
      <el-col
        v-if="messageModel.onsite_type === onsiteTypes.INLINE"
        :md="24"
        :lg="14"
        :xl="16"
        class="preview-inline"
      >
        <native-inline-preview :message="messageModel.onsite" />
      </el-col>
      <el-col v-else :md="24" :lg="14" :xl="16" class="preview">
        <div
          v-if="messageModel.onsite_type === onsiteTypes.ALERT"
          class="message-preview"
        >
          <onsite-message-preview :message="message" />
        </div>
        <div
          v-if="messageModel.onsite_type === onsiteTypes.POPUP"
          class="popup-preview"
        >
          <div class="popup-container use-deprecated-styles">
            <onsite-popup-preview :config="config" ref="popup" @fire="fire" />
          </div>
        </div>
      </el-col>
    </el-row>
  </form-section>
</template>

<script>
import { EventBus } from '@/core/EventBus'
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import { defaultMessages } from '@/modules/campaign-manage/enum/DefaultMessages'
import FormSection from '@/common/components/form/FormSection'
import OnsitePopupPreview from '@/common/components/onsite/OnsitePopupPreview'
import OnsiteMessagePreview from '@/common/components/onsite/OnsiteMessagePreview'
import FormItem from '@/common/components/form/FormItem'
import Checkbox from '@/common/components/form/Checkbox'
import Redactor from '@/common/components/Redactor'
import EnumSelect from '@/common/components/form/EnumSelect'
import ColorPickerField from '@/common/components/form/ColorPickerField'
import SnippetInput from '@/modules/campaign-manage/components/SnippetInput'
import OnSiteButtonForm from '@/modules/campaign-manage/components/content/channels/OnSiteButtonForm'
import ImagePlaceholder from '@/img/upload-image.png'
import _ from 'lodash'
import CampaignImageUpload from '@/modules/campaign-manage/components/content/CampaignImageUpload'
import ContentActions from '@/modules/campaign-manage/components/ContentActions'
import {
  onsiteTypes,
  typeLabels
} from '@/modules/campaign-manage/enum/OnsiteTypesEnum'
import { subscriptionTypes } from '@/modules/campaign-manage/enum/InAppTypesEnum'
import NativeInlinePreview from '@/modules/campaign-manage/components/content/channels/NativeInlinePreview'
import NativeInlineForm from '@/modules/campaign-manage/components/content/channels/NativeInlineForm'
import InlinePreference from '@/modules/campaign-manage/components/setup/InlinePreference'

export default {
  name: 'OnSite',
  components: {
    InlinePreference,
    ContentActions,
    NativeInlineForm,
    NativeInlinePreview,
    CampaignImageUpload,
    OnSiteButtonForm,
    SnippetInput,
    ColorPickerField,
    EnumSelect,
    Redactor,
    Checkbox,
    FormItem,
    OnsiteMessagePreview,
    OnsitePopupPreview,
    FormSection
  },
  data() {
    return {
      onsiteTypes,
      channelTypes,
      subscriptionTypes,
      titleKey: '',
      textKey: '',
      footerKey: '',
      tab: 'content',
      actions: {
        none: 'CampaignForm_Onsite_Action_None',
        url: 'CampaignForm_Onsite_Action_Url',
        deeplink: 'CampaignForm_Onsite_Action_DeepLink',
        inapp: 'CampaignForm_Onsite_Action_InApp',
        javascript: 'CampaignForm_Onsite_Action_Javascript'
      },
      scrollOptions: {
        page: 'CampaignForm_Onsite_Scroll_Page',
        content: 'CampaignForm_Onsite_Scroll_Content'
      },
      imageOptions: {
        none: 'CampaignForm_Onsite_Image_None',
        upload: 'CampaignForm_Onsite_Image_Upload',
        url: 'CampaignForm_Onsite_Image_Url',
        success: 'CampaignForm_Onsite_Image_Success',
        error: 'CampaignForm_Onsite_Image_Error',
        warning: 'CampaignForm_Onsite_Image_Warning',
        info: 'CampaignForm_Onsite_Image_Info',
        question: 'CampaignForm_Onsite_Image_Question'
      },
      inlinePreferenceKey: 0
    }
  },
  props: {
    value: {
      required: true
    },
    title: {
      required: true
    },
    model: {
      required: true
    }
  },
  beforeMount() {
    if (!this.messageModel.onsite) {
      let popup = _.cloneDeep(defaultMessages[channelTypes.onsite].onsite.popup)
      this.$set(this.model, 'onsite', popup)
    }
    this.applyInlinePreferenceDefaults()
  },
  mounted() {
    if (
      this.messageModel.onsite_type === onsiteTypes.INLINE &&
      !this.messageModel.onsite.hasOwnProperty('native')
    ) {
      this.$set(
        this.messageModel.onsite,
        'native',
        _.cloneDeep(defaultMessages[channelTypes.onsite].onsite.native)
      )
    }
    this.parseCheckboxes(this.messageModel.onsite.popup)
    this.applyStyles()
    EventBus.$on('applyPushTemplate-' + this.key, data => {
      if (
        data.onsite_type === onsiteTypes.POPUP &&
        data.onsite &&
        data.onsite.popup
      ) {
        const button0 = {
          ...this.messageModel.onsite.popup.button0,
          ...(data.onsite.popup.button0 || {})
        }
        if (button0.add_to_list) {
          button0.add_to_list = parseInt(button0.add_to_list) || null
        }
        const button1 = {
          ...this.messageModel.onsite.popup.button1,
          ...(data.onsite.popup.button1 || {})
        }
        if (button1.add_to_list) {
          button1.add_to_list = parseInt(button1.add_to_list) || null
        }
        const style = {
          ...this.messageModel.onsite.popup.style,
          ...(data.onsite.popup.style || {})
        }
        this.messageModel.onsite.popup = {
          ...this.messageModel.onsite.popup,
          ...data.onsite.popup
        }

        this.messageModel.onsite.popup.button0 = button0
        this.messageModel.onsite.popup.button1 = button1
        this.messageModel.onsite.popup.style = style
        if (!data.onsite.popup.button0.enabled) {
          this.messageModel.onsite.popup.button0.enabled = 0
        }
        if (!data.onsite.popup.button1.enabled) {
          this.messageModel.onsite.popup.button1.enabled = 0
        }

        this.parseCheckboxes(data.onsite.popup)
      }

      if (data.onsite_type === onsiteTypes.INLINE && data.onsite.native) {
        this.$set(this.messageModel.onsite, 'native', data.onsite.native)
        // Set Template
        if (this.messageModel.onsite.native.payload.form) {
          this.$set(
            this.messageModel.onsite.native.payload,
            'formTemplate',
            this.messageModel.onsite.native.payload.form
          )
        }

        // Set empty Form Values
        if (
          !Object.keys(this.messageModel.onsite.native.payload.formValues)
            .length
        ) {
          this.messageModel.onsite.native.payload.formValues = {}
          Object.keys(
            this.messageModel.onsite.native.payload.formSettings
          ).forEach(key => {
            this.$set(
              this.messageModel.onsite.native.payload.formValues,
              key,
              null
            )
          })
        }
      }

      this.titleKey = new Date().getTime() + '_title'
      this.textKey = new Date().getTime() + '_text'
      this.footerKey = new Date().getTime() + '_footer'
    })
    setTimeout(() => {
      EventBus.$emit('updateInitialStateMessages', this.model.messages)
    })
  },
  computed: {
    footerHtml() {
      return (
        this.inlinePreferenceHtml +
        `<div class="footer-content">${
          this.messageModel.onsite.popup.footer
            ? this.messageModel.onsite.popup.footer
            : ''
        }</div>`
      )
    },
    inlineButtonStyles() {
      let style = {
        'background-color': this.messageModel.onsite.popup.style
          .color_inline_button_background,
        color: this.messageModel.onsite.popup.style.color_inline_button_text,
        'border-color': this.messageModel.onsite.popup.style
          .color_inline_button_border
      }
      return Object.entries(style)
        .map(([k, v]) => `${k}:${v}`)
        .join(';')
    },
    inlinePreferenceHtml() {
      let ageConfirmationBlock = ''
      let termsBlock = ''
      let contactFieldBlock = ''

      if (this.value.onsite.popup.inline_preference.age_confirmation_enabled) {
        ageConfirmationBlock = `
            <div class="checkbox-container">
              <label class="el-checkbox is-checked">
                <span class="el-checkbox__input is-checked">
                  <span class="el-checkbox__inner"
                   style="background-color: ${this.messageModel.onsite.popup.style.color_inline_checkbox}">
                  </span>
                </span>
              </label>
              <span style="color: ${this.messageModel.onsite.popup.style.color_inline_text}">
                ${this.messageModel.onsite.popup.inline_preference.age_confirmation_text}
              </span>
            </div>`
      }

      if (this.value.onsite.popup.inline_preference.terms_enabled) {
        termsBlock = `
            <div class="checkbox-container">
              <label class="el-checkbox is-checked">
                <span class="el-checkbox__input is-checked">
                  <span class="el-checkbox__inner"
                   style="background-color: ${this.messageModel.onsite.popup.style.color_inline_checkbox}">
                  </span>
                </span>
              </label>
              <span style="color: ${this.messageModel.onsite.popup.style.color_inline_text}">
                ${this.messageModel.onsite.popup.inline_preference.terms_text}
              </span>
            </div>`

        if (this.value.onsite.popup.inline_preference.contact_field) {
          let placeHolder = this.$t(
            'CampaignForm_Onsite_InlinePreference_EmailField'
          )
          if (
            this.value.onsite.popup.inline_preference.subscription ===
            subscriptionTypes.SMS
          ) {
            placeHolder = this.$t(
              'CampaignForm_Onsite_InlinePreference_PhoneField'
            )
          }
          contactFieldBlock = `
            <div class="el-input contact-field">
                <input type="text" placeholder="${placeHolder}" class="el-input__inner">
            </div>`
        }
      }

      const optInBlock = `
        <div class="checkbox-container">
          <label class="el-checkbox is-checked">
            <span class="el-checkbox__input is-checked">
              <span class="el-checkbox__inner"
               style="background-color: ${this.messageModel.onsite.popup.style.color_inline_checkbox}">
              </span>
            </span>
          </label>
          <span style="color: ${this.messageModel.onsite.popup.style.color_inline_text}">
            ${this.messageModel.onsite.popup.inline_preference.opt_in}
          </span>
        </div>`

      return this.value.onsite_type === onsiteTypes.POPUP &&
        this.messageModel.onsite.popup.inline_preference
        ? `<div class="inline-preferences">
        ${ageConfirmationBlock}
        ${termsBlock}
        ${optInBlock}
        ${contactFieldBlock}
        <div class="el-row" style="margin-left: -10px; margin-right: -10px; text-align: center;">
          <div class="el-col el-col-24" style="margin: 10px 0px;">
            <button
              type="button"
              class="el-button el-button--primary"
              style="${this.inlineButtonStyles}"
            >
              <span>${this.messageModel.onsite.popup.inline_preference.button}</span>
            </button>
          </div>
        </div>
      </div>`
        : null
    },
    messageModel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    actionModel: {
      get() {
        if (!this.messageModel.push_action.action) {
          this.$set(this.messageModel.push_action, 'action', 'none')
        }
        return this.messageModel.push_action.action
      },
      set(val) {
        this.$set(
          this.messageModel.push_action,
          'action',
          val === 'none' ? '' : val
        )
      }
    },
    key() {
      return `${this.$route.query.channel}_${this.$route.query.variant}_${this.$route.query.lang}`
    },
    message() {
      return {
        icon: this.messageModel.push_icon,
        title: this.messageModel.push_title,
        text: this.messageModel.push_text
      }
    },
    enabledButtons() {
      return (
        parseInt(this.messageModel.onsite.popup.button0.enabled || 0) +
        parseInt(this.messageModel.onsite.popup.button1.enabled || 0)
      )
    },
    config() {
      let config = {
        background: this.messageModel.onsite.popup.style.color_background,
        backdrop: this.convertHex(
          this.messageModel.onsite.popup.style.color_backdrop
        ),
        showConfirmButton: false,
        showCancelButton: false,
        imageUrl: this.messageModel.onsite.popup.image_checkbox
          ? ImagePlaceholder
          : null,
        imageHeight: '150px',
        icon: null,
        width: this.messageModel.onsite.popup.message_size.width + 'px'
      }

      // Image
      if (this.messageModel.onsite.popup.image_checkbox) {
        const isDefaultImgType = !['none', 'upload', 'url'].includes(
          this.messageModel.onsite.popup.image_type
        )

        if (isDefaultImgType) {
          config.imageUrl = null
          config.icon = this.messageModel.onsite.popup.image_type
        } else {
          if (this.messageModel.onsite.popup.image_type === 'url') {
            config.imageUrl =
              this.messageModel.onsite.popup.image_url || ImagePlaceholder
          } else {
            config.imageUrl =
              this.messageModel.onsite.popup.image || ImagePlaceholder
          }
          if (this.messageModel.onsite.popup.image_height) {
            config.imageHeight =
              this.messageModel.onsite.popup.image_height + 'px'
          }
        }
      }

      // Title, text, footer
      config.title = this.messageModel.onsite.popup.title_checkbox
        ? this.messageModel.onsite.popup.title || 'Title'
        : null
      config.html = this.messageModel.onsite.popup.text_checkbox
        ? this.messageModel.onsite.popup.main_text || 'Message content'
        : null
      config.footer = this.footerHtml

      // Buttons
      if (this.enabledButtons) {
        config.showConfirmButton = true
        config.confirmButtonText =
          this.messageModel.onsite.popup.button0.text || 'OK'
        config.confirmButtonColor = this.messageModel.onsite.popup.style.color_button_0_background
      }

      if (this.enabledButtons > 1) {
        config.showCancelButton = true
        config.cancelButtonText =
          this.messageModel.onsite.popup.button1.text || 'Cancel'
        config.cancelButtonColor = this.messageModel.onsite.popup.style.color_button_1_background
      }

      if (this.messageModel.onsite.popup.email_checkbox) {
        config.input = 'email'
        config.inputPlaceholder = 'info@example.com'
        config.inputAttributes = {}
      } else {
        config.input = undefined
      }

      // Styles
      this.applyStyles()

      return config
    },

    disabled() {
      if (this.messageModel.onsite_type === this.onsiteTypes.ALERT) {
        return !(this.messageModel.push_title || this.messageModel.push_text)
      }

      if (this.messageModel.onsite_type === this.onsiteTypes.POPUP) {
        return !(
          this.messageModel.onsite.popup.title ||
          this.messageModel.onsite.popup.text ||
          this.messageModel.onsite.popup.footer
        )
      }

      return true
    },

    onsiteAvailableTypes() {
      let types = { ...typeLabels }

      if (!this.$store.state.app.features.inapp_native) {
        this.$delete(types, onsiteTypes.INLINE)
      }
      return types
    }
  },
  methods: {
    fire() {
      setTimeout(() => {
        this.applyStyles()
      })
    },
    parseCheckboxes(data) {
      this.messageModel.onsite.popup.email_checkbox = parseInt(
        data.email_checkbox || 0
      )
      this.messageModel.onsite.popup.email_subscription = parseInt(
        data.email_subscription || 0
      )
      this.messageModel.onsite.popup.image_type = data.image_type || 'none'
      this.messageModel.onsite.popup.image_checkbox = parseInt(
        data.image_checkbox || 0
      )
      this.messageModel.onsite.popup.title_checkbox = parseInt(
        data.title_checkbox || 0
      )
      this.messageModel.onsite.popup.text_checkbox = parseInt(
        data.text_checkbox || 0
      )
      this.messageModel.onsite.popup.footer_checkbox = parseInt(
        data.footer_checkbox || 0
      )
    },
    updateContent(content) {
      this.messageModel.push_text = content
    },
    setValue(val) {
      this.messageModel.onsite.popup.button0.enabled = val ? 1 : 0
      this.messageModel.onsite.popup.button1.enabled = val === 2 ? 1 : 0
    },
    convertHex(color) {
      color = color.replace('#', '')
      const r = parseInt(color.substring(0, 2), 16)
      const g = parseInt(color.substring(2, 4), 16)
      const b = parseInt(color.substring(4, 6), 16)
      return `rgba(${r}, ${g}, ${b}, ${this.messageModel.onsite.popup.style
        .opacity_backdrop / 100})`
    },
    applyStyles() {
      if (!this.$refs.popup) {
        return
      }
      this.$refs.popup.$el.querySelector(
        '.swal2-title'
      ).style.color = this.messageModel.onsite.popup.style.color_title

      this.$refs.popup.$el.querySelector(
        '.swal2-html-container'
      ).style.color = this.messageModel.onsite.popup.style.color_text

      this.$refs.popup.$el.querySelector('.swal2-popup').style.opacity =
        this.messageModel.onsite.popup.style.opacity_background / 100

      this.$refs.popup.$el.querySelector(
        '.swal2-confirm'
      ).style.background = this.messageModel.onsite.popup.style.color_button_0_background
      this.$refs.popup.$el.querySelector(
        '.swal2-confirm'
      ).style.color = this.messageModel.onsite.popup.style.color_button_0_text

      this.$refs.popup.$el.querySelector(
        '.swal2-cancel'
      ).style.background = this.messageModel.onsite.popup.style.color_button_1_background
      this.$refs.popup.$el.querySelector(
        '.swal2-cancel'
      ).style.color = this.messageModel.onsite.popup.style.color_button_1_text

      this.$refs.popup.$el.querySelector('.swal2-footer').style.display =
        'block'
      this.$refs.popup.$el.querySelector('.swal2-footer').style.border = 'none'
      this.$refs.popup.$el.querySelector(
        '.swal2-footer .inline-preferences'
      ).style.textAlign = 'center'

      this.$refs.popup.$el.querySelector(
        '.swal2-footer .footer-content'
      ).style.color = this.messageModel.onsite.popup.style.color_footer
      this.$refs.popup.$el.querySelector(
        '.swal2-footer .footer-content'
      ).style.textAlign = 'center'
      this.$refs.popup.$el.querySelector(
        '.swal2-footer .footer-content'
      ).style.borderTop = `1px solid ${this.messageModel.onsite.popup.style.color_footer_separator}`
      this.$refs.popup.$el.querySelector(
        '.swal2-footer .footer-content'
      ).style.marginTop = `15px`

      this.$refs.popup.$el.querySelector(
        '.swal2-footer .footer-content'
      ).style.display = this.messageModel.onsite.popup.footer_checkbox
        ? `block`
        : 'none'

      this.$refs.popup.$el.querySelector(
        '.swal2-footer .inline-preferences'
      ).style.display = this.messageModel.onsite.popup.inline_preference.enabled
        ? `block`
        : 'none'
    },
    applyInlinePreferenceDefaults() {
      if (
        !this.value.onsite.popup.inline_preference &&
        this.value.onsite_type === onsiteTypes.POPUP
      ) {
        let inlinePreference = _.cloneDeep(
          defaultMessages[channelTypes.onsite].onsite.popup.inline_preference
        )
        _.forOwn(
          defaultMessages[channelTypes.onsite].onsite.popup.style,
          (val, key) => {
            if (key.search('color_inline') !== -1) {
              this.$set(this.value.onsite.popup.style, key, val)
            }
          }
        )
        this.$set(
          this.value.onsite.popup,
          'inline_preference',
          inlinePreference
        )
      }
    }
  },

  watch: {
    'messageModel.onsite.popup': {
      handler() {
        this.$nextTick(() => {
          this.applyInlinePreferenceDefaults()
          this.applyStyles()
        })
      },
      deep: true
    },
    'messageModel.onsite.native.payload_type': {
      handler(payloadType) {
        if (
          payloadType === 'json' &&
          !Array.isArray(this.value.onsite.native.payload.json)
        ) {
          this.value.onsite.native.payload.json = []
        }
      }
    },
    'messageModel.onsite_type': {
      handler(onsiteType) {
        if (onsiteType === onsiteTypes.POPUP) {
          this.applyInlinePreferenceDefaults()
          if (
            this.messageModel.onsite.popup.button0.enabled === 1 &&
            !this.messageModel.onsite.popup.button0.hasOwnProperty('action')
          ) {
            this.messageModel.onsite.popup = _.cloneDeep(
              defaultMessages[channelTypes.onsite].onsite.popup
            )
          }
        } else if (onsiteType === onsiteTypes.INLINE) {
          if (!this.messageModel.onsite.hasOwnProperty('native')) {
            this.$set(
              this.messageModel.onsite,
              'native',
              _.cloneDeep(defaultMessages[channelTypes.onsite].onsite.native)
            )
          }
        }
      }
    },
    'messageModel.onsite.popup.inline_preference': {
      handler(val) {
        if (val && val.button === null) {
          this.inlinePreferenceKey++
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.checkbox {
  background-color: #f8fafc;
}
.upload >>> .el-upload {
  width: 100% !important;
}
.checkbox >>> .el-form-item {
  margin-bottom: 0;
}
.checkbox >>> .el-form-item:nth-child(2) {
  margin-top: 22px;
}
.p-top-136 {
  padding-top: 136px;
}
>>> .el-input-number {
  width: 100%;
}
.input-number >>> input,
.select >>> input {
  height: 38px;
}
/deep/ .color-picker-ct {
  width: 100% !important;
}
.redactor,
/deep/ .el-tabs__content,
.form-section {
  overflow: visible;
}
.preview {
  background-color: #f8fafc;
  border-radius: 4px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  max-width: 100%;
}
.preview-inline {
  padding: 20px 10px;
  background-color: #f8fafc;
  overflow: hidden;
}
.popup-preview {
  background: url('../../../../../img/checker-transparency.jpg') repeat;
  margin: 40px 30px;
  width: 100%;
}
.popup-container {
  width: 100%;
}
.message-preview {
  width: 370px;
  margin: 25px auto;
}
>>> .swal2-footer {
  display: block !important;
}
.styles .el-form-item {
  margin-bottom: 0px !important;
}
.styles-section {
  margin-bottom: 25px;
}
/deep/ .inline-preferences {
  text-align: left;
  padding: 0 20px;
}

/deep/ .checkbox-container {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
  text-align: left;
}

/deep/ .el-checkbox__input {
  flex-shrink: 0;
}

/deep/ .contact-field {
  margin: 10px auto;
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/OnSite.vue